import { Trash2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DeleteButtonProps {
  isPending?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  size?: 'default' | 'sm';
  className?: string;
}

export function DeleteButton({
  isPending = false,
  children,
  disabled,
  onClick,
  size,
  className,
}: DeleteButtonProps): React.ReactElement {
  const text = children ?? (isPending ? 'Deleting...' : 'Delete');

  return (
    <Button
      type="button"
      variant="destructive"
      size={size}
      className={className}
      disabled={isPending || disabled}
      onClick={onClick}
    >
      {isPending ? (
        <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />
      ) : (
        <Trash2 className="mr-1.5 h-3.5 w-3.5" />
      )}
      {text}
    </Button>
  );
}
